import { render } from "./AddUserPage.vue?vue&type=template&id=41913f06&lang=html"
import script from "./AddUserPage.vue?vue&type=script&lang=js"
export * from "./AddUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__